const textFieldFormEquipModel = {
  name: 'Tipo de Equipo',
  description: 'Descripción del Tipo de Equipo',
  labelDepreciation: 'Depreciación Anual',
  labelPercentualDepreciation: 'valor entre 0 y 100',
};

export default textFieldFormEquipModel;
